import React, { useState } from 'react';

const PastaForm = ({ location, initialName = '', onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    name: initialName,
    pastaScores: {
      parking: 5,
      access: 5,
      signing: 5,
      traffic: 5,
      activity: 5,
      visibility: 5
    },
    status: 'scouting',
    metadata: {
      notes: ''
    }
  });

  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('pasta.')) {
      const field = name.split('.')[1];
      setFormData({
        ...formData,
        pastaScores: {
          ...formData.pastaScores,
          [field]: parseInt(value)
        }
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);
    try {
      onSubmit({
        ...formData,
        coordinates: [location.lng, location.lat],
        file: file // The handler in Dashboard will need to handle FormData
      });
    } finally {
      setUploading(false);
    }
  };

  const pastaFields = [
    { name: 'parking', label: 'P - Parking' },
    { name: 'access', label: 'A - Access' },
    { name: 'signing', label: 'S - Signing' },
    { name: 'traffic', label: 'T - Traffic' },
    { name: 'activity', label: 'A - Activity' },
    { name: 'visibility', label: 'V - Visibility' }
  ];

  return (
    <div style={{
      background: 'rgba(5, 7, 10, 0.95)',
      border: '1px solid #0B3D91',
      padding: '20px',
      borderRadius: '4px',
      color: '#F0F0F0',
      width: '350px',
      maxWidth: 'calc(100vw - 40px)',
      maxHeight: 'calc(100dvh - 120px)',
      overflowY: 'auto'
    }}>
      <h2 style={{ color: '#E27B58', fontSize: '1.2rem', marginBottom: '15px' }}>PASTA V SITE EVALUATION</h2>
      <p style={{ fontSize: '0.75rem', color: '#888', marginBottom: '15px' }}>
        COORDINATES: {location.lat.toFixed(6)}, {location.lng.toFixed(6)}
      </p>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', fontSize: '0.8rem', marginBottom: '5px' }}>SITE NAME</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="nasa-input"
            placeholder="e.g. M-30 North Exit 12"
            style={{ width: '100%' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', fontSize: '0.8rem', marginBottom: '5px' }}>MISSION STATUS</label>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="nasa-input"
          >
            <option value="scouting">SCOUTING (Initial Phase)</option>
            <option value="validation">VALIDATION (Site Visit)</option>
            <option value="negotiation">NEGOTIATION (Real Estate)</option>
            <option value="approved">MISSION APPROVED</option>
            <option value="rejected">MISSION ABORTED</option>
          </select>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '15px' }}>
          {pastaFields.map(field => (
            <div key={field.name}>
              <label style={{ display: 'block', fontSize: '0.7rem', marginBottom: '3px' }}>{field.label}</label>
              <input
                type="number"
                min="1"
                max="10"
                name={`pasta.${field.name}`}
                value={formData.pastaScores[field.name]}
                onChange={handleChange}
                className="nasa-input"
                style={{ width: '100%', padding: '5px' }}
              />
            </div>
          ))}
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontSize: '0.8rem', marginBottom: '5px' }}>MISSION NOTES</label>
          <textarea
            name="metadata.notes"
            onChange={(e) => setFormData({...formData, metadata: { ...formData.metadata, notes: e.target.value }})}
            className="nasa-input"
            style={{ width: '100%', height: '60px', resize: 'none' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', fontSize: '0.8rem', marginBottom: '5px' }}>MISSION EVIDENCE (Photo/PDF)</label>
          <input
            type="file"
            onChange={(e) => setFile(e.target.files[0])}
            className="nasa-input"
            style={{ width: '100%', fontSize: '0.7rem' }}
            accept=".jpg,.jpeg,.png,.pdf"
          />
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button type="submit" disabled={uploading} className="nasa-button" style={{ flex: 1 }}>
            {uploading ? 'UPLOADING...' : 'SAVE DATA'}
          </button>
          <button type="button" onClick={onCancel} className="nasa-button" style={{ flex: 1, backgroundColor: 'transparent' }}>ABORT</button>
        </div>
      </form>
    </div>
  );
};

export default PastaForm;
